import initActivationVerification from './CheckUserActivationService'

export default initActivationVerification
